<template>

    <div class="container-fluid p-0" v-if="!is_expired">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class=" login-card  card login-dark">
                    <div  >
                        <div class="card-header"  >
                            <h4>Gatepass Details </h4>
                                                            
                                                            <span v-if="gatepass.check_out!=null" class="badge badge-pill badge-success text-white">
                                                                    Checked Out
                                                            </span>
                                                            <span v-else-if="gatepass.checkout_approval==1" class="badge badge-pill badge-warning text-white">
                                                                    Check Out Approved {{gatepass?.checkout_approval_time}}
                                                            </span>
                                                            <span v-else-if="gatepass.checkout_approval==2" class="badge badge-pill badge-warning text-white">
                                                                    Check Out Denied
                                                            </span>
                                                            <span v-else-if="gatepass.check_in!=null" class="badge badge-pill badge-info text-white">
                                                                    Checked In
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==0" class="badge badge-pill badge-warning text-white">
                                                                    Pending
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==1" class="badge badge-pill badge-success text-white">
                                                                    Accepted
                                                            </span>
                                                            <span v-else-if="gatepass.approval_status==2" class="badge badge-pill badge-danger text-white">
                                                                    Denied
                                                            </span>
                        </div>

                        <div class="card-body bg-white">
                            <div class="row">
                                <div class="col-12 text-center"  @click="show_img_modal('QR','QR Code')">
                                    <canvas ref="qrcodeCanvas"></canvas>
                                </div>
                                <div class="col-3 ">
                                    <div class="avatar" @click="show_img_modal(this.$hostname+'writable/uploads/visitors/'+(gatepass.gphoto?gatepass.gphoto:(gatepass.photo?gatepass.photo:'user.png')),'User Image')">
                                        <img alt="" class="img img-thumbnail" :src="this.$hostname+'writable/uploads/visitors/'+(gatepass.gphoto?gatepass.gphoto:(gatepass.photo?gatepass.photo:'user.png'))" v-if="gatepass.photo"></div>
                                </div>
                                <div class="col-9 ">
                                        <b>Name :</b>  {{ gatepass.name }}<br>
                                        <b>Phone No :</b>  {{ gatepass.contact }}<br>
                                        <b>Firm Name :</b>  {{ gatepass.firmname }}<br> 
                                        <b>Address :</b>  {{ gatepass.address }}<br> 
                                </div>
                            </div>
                            <div class="col-12 mt-4 row"> 
                                <table class="table">
                                    <tr class="bottomborder">
                                        <td><b>Staff</b></td>
                                        <td>{{ gatepass.whom_name }}</td>
                                    </tr>
                                    <tr class="bottomborder">
                                        <td><b>Purpose</b></td>
                                        <td>{{ gatepass.purpose }}</td>
                                    </tr>
                                    <tr class="bottomborder">
                                        <td><b>Schedule Date</b></td>
                                        <td>{{ gatepass.schedule_date }}</td>
                                    </tr>
                                    <tr v-if="gatepass.meeting_room" class="bottomborder">
                                        <td><b>Meeting Schedule</b></td>
                                        <td>{{ gatepass.meeting_room }}</td>
                                    </tr> 
                                    <tr v-if="gatepass.check_in" class="bottomborder">
                                        <td><b>Check In</b></td>
                                        <td>{{ gatepass.check_in }}</td>
                                    </tr> 
                                    <tr v-if="gatepass.check_out" class="bottomborder">
                                        <td><b>Check Out</b></td>
                                        <td>{{ gatepass.check_out }}</td>
                                    </tr> 
                                    
                                    
                                   
                                    
                                    
                                    
                                </table>
                             
                                   
                            </div>
                            <div class="form-group col-12 mt-4 ">
                                    {{gatepass.accessories}}
                            </div>
                            
                            <!--<div class="form-group col-12 mt-4 ">-->
                            <!--  <lable class="col-3"> Visitor Sign</lable> &nbsp;&nbsp;&nbsp;&nbsp;-->
                            <!--  <lable class="col-3"> Employee Sign</lable>&nbsp;&nbsp;&nbsp;&nbsp;-->
                            <!--  <lable class="col-3"> Security Sign</lable>-->
                            <!--</div> -->
                            <div class="card-footer bg-white row" v-if="scan_user && scan_user?.empdept==sd" >
                                <div v-if="gatepass.check_in==null" class="col-12">
                                    <button v-if="gatepass.approval_status==1" class="btn btn-success col-12" @click="first_capture_photo(gatepass.visitid,1)">Check In</button>
                                    <div v-else class="text-danger">Check-In Not Approved</div>
                                </div>
                                
                              
                                
                                <div v-if="gatepass.check_in!=null" class="col-12">
                                    <button v-if="gatepass.checkout_approval==1 && gatepass.check_out==null" class="btn btn-danger col-12" @click="mark_checkin(gatepass.visitid,2)">Check Out</button>
                                    <div v-else-if='gatepass.check_out' class="text-danger">Check-Out Done</div>
                                    <div v-else class="text-danger">Check-Out Not Approved</div>
                                </div>
                            </div> 
                            </div> 
                    </div>
                     <button v-if="scan_user?.empdept==sd" class="btn btn-danger" @click="this.$router.go(-1);">Go Back</button>
                </div>
            </div>
        </div>
    </div>


 <div class="modal" v-if="showimgModal" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Capture Image</h5>
              <button type="button" class="btn close btn-danger text-white" @click="showimgModal=!showimgModal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-6 card text-center mb-5">
                        <video ref="video" autoplay  ></video>
                         <span type="button" class="badge bg-danger" @click="this.startWebcam()">Restart Camera</span>
                      
                    </div>
                    <div class="col-6">
                         <!-- <div class="avatar">
                            <img :src="photo" alt="Captured photo" class="img-100" style="height: 100px;">
                        </div>  -->
                        <canvas ref="canvas"  style="height: 100px;"></canvas>
                         <span type="button" class="btn btn-success col-11" @click="capture_photo">Capture</span>
                    </div>
                </div>
                <!-- <button @click="capturePhoto" class="btn btn-primary mt-3">Capture Photo</button> -->
            </div>
            
            <div class="modal-footer">
            
             <button type="button" class="btn btn-primary" @click="mark_checkin(imgpassid, 1)">Check In</button> 
            </div>
          </div>
        </div>
      </div>


    <div class="modal fade" id="showingImg" tabindex="-1" role="dialog" aria-labelledby=" " aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{showingUserPic.title}}</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">

                            <img alt=""
                                :src="showingUserPic.src" class="img img-thumbnail"
                                /> 

                        </div>
                    </div>
                </div>
                <!--<div class="modal-footer">-->
                <!--    <div class="col-12">-->
                <!--        <button class="btn btn-primary" @click=""> </button>-->
                <!--    </div>-->
                <!--</div>-->
            </div>
        </div>
    </div>
    
    
        <audio  ref="checkoutPlayer" src="/sounds/checkout.mp3"></audio>
        <audio  ref="checkinPlayer"  src="/sounds/checkin.mp3"></audio>
        <audio  ref="invalidPlayer"  src="/sounds/invalid.mp3"></audio>
        <audio  ref="pendingPlayer"  src="/sounds/pending.mp3"></audio>
        <audio  ref="photoPlayer"  src="/sounds/photo.mp3"></audio>
        
        
</template>
<style scoped>
.bottomborder{
    border-bottom: 1px solid grey;
}
.page-body {
    margin-left: 0 !important;
    margin-top: 0px;
}

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
}
.avatar img{
    width: 100%; 
}
.login-card {
    min-height: 80vh;
}

</style>

<script>
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'VisitorGatepassView',
    components: {

    },
    mounted() {
        if (this.$route.query.q) {
                this.getBasics(this.$route.query.q);
            }else
            window.location.href = this.$cur_host+'register';
    },
    watch: {
        showimgModal(newVal) {
            if (newVal) {
            this.$nextTick(() => {
                this.startWebcam();
            });
            }
        }
    },
    data() {
        return {  
            gatepass: { "name": '', "firmname": '',"contact": '', "address": '',"purpose": '','designation':'','schedule_date':'','photo':'' } ,
            status:'',
             scan_user:'',
             sd:0,
             showimgModal:false,
             selected_gatepass_captured_img:'',
             imgpassid:0,
             is_expired:false,
             showingUserPic:[]
        }
    },
    methods: { 
        //  async startWebcam() {
        //         try {
        //             const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        //             this.$refs.video.srcObject = stream;
        //         } catch (error) {
        //             console.error("Error accessing webcam:", error);
        //         }
        //     },
        
        //comment on 13.05.2025_7_51
        // async startWebcam() {
        //   try {
        //     const devices = await navigator.mediaDevices.enumerateDevices();
        //     const videoDevices = devices.filter(device => device.kind === 'videoinput');
        
        //     // Prefer camera with 'back' or 'usb' in label (label is only available after user grants permission)
        //     let preferredDevice = videoDevices.find(device =>
        //       device.label.toLowerCase().includes('back') ||
        //       device.label.toLowerCase().includes('rear') ||
        //       device.label.toLowerCase().includes('usb')
        //     );
        
        //     // Fallback to last device (usually rear camera on phones)
        //     if (!preferredDevice && videoDevices.length > 1) {
        //       preferredDevice = videoDevices[videoDevices.length - 1];
        //     } else if (!preferredDevice) {
        //       preferredDevice = videoDevices[0]; // Use first as last resort
        //     }
        
        //     const stream = await navigator.mediaDevices.getUserMedia({
        //       video: {
        //         deviceId: preferredDevice.deviceId ? { exact: preferredDevice.deviceId } : undefined
        //       }
        //     });
        
        //     this.$refs.video.srcObject = stream;
        
        //   } catch (error) {
        //     console.error("Error accessing webcam:", error);
        //   }
        // },
        
        //replace comment on 13.05.2025_7_51
        async startWebcam() {
              try {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const videoDevices = devices.filter(device => device.kind === 'videoinput');
            
                // Basic tablet detection
                const isTablet = /ipad|android(?!.*mobile)/i.test(navigator.userAgent);
            
                let preferredDevice;
            
                // if (isTablet) {
                //   // Prefer front camera on tablets
                //   preferredDevice = videoDevices.find(device =>
                //     device.label.toLowerCase().includes('front') ||
                //     device.label.toLowerCase().includes('user')
                //   );
                // } else {
                //   // Prefer back camera on phones or fallback devices
                //   preferredDevice = videoDevices.find(device =>
                //     device.label.toLowerCase().includes('back') ||
                //     device.label.toLowerCase().includes('rear') ||
                //     device.label.toLowerCase().includes('environment')
                //   );
                // }
                
                //camera changed on 27.06.2025
                
                  preferredDevice = videoDevices.find(device =>
                    device.label.toLowerCase().includes('front') ||
                    device.label.toLowerCase().includes('user')
                  );
               
            
                // Fallback to last or first available device
                if (!preferredDevice && videoDevices.length > 1) {
                  preferredDevice = videoDevices[videoDevices.length - 1];
                } else if (!preferredDevice) {
                  preferredDevice = videoDevices[0];
                }

                const stream = await navigator.mediaDevices.getUserMedia({
                  video: {
                    deviceId: preferredDevice.deviceId ? { exact: preferredDevice.deviceId } : undefined
                  }
                });
            
                this.$refs.video.srcObject = stream;
            
              } catch (error) {
                console.error("Error accessing webcam:", error);
              }
            },

        
        
        first_capture_photo(passid,itemid){
                var self=this;
                self.imgpassid=passid; 
                self.showimgModal = true; 
            },
 


         capture_photo(){
 
                const video = this.$refs.video;
                const canvas = this.$refs.canvas;
                const context = canvas.getContext('2d');

                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                context.drawImage(video, 0, 0, canvas.width, canvas.height);

                this.selected_gatepass_captured_img = canvas.toDataURL('image/png');
      
              
         },
     dataURLtoBlob(dataURL) {
                const byteString = atob(dataURL.split(',')[1]);
                const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ab], { type: mimeString });
            },

        mark_checkin(passid,what) {
            var self = this;
            if(what==2){
            
                self.$swal({
                    title: "Do You Want To Check Out?",
                    text: "Just For Confirmation !",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                    
                        if(!passid){
                            self.$swal("Something Wrong");
                            return;
                        }
                
                        const formData = new FormData();
                        if(what==1){
                            const blob = self.dataURLtoBlob(self.selected_gatepass_captured_img);
                            formData.append('image', blob, 'captured_photo.png');
                        }
                        // formData.append('passid', passid);
                        formData.append('passid', passid);
                        formData.append('what', what);
                        
                        axios.post('qrcheckInUser', formData).then(function (response) {
                            if(response.data?.sound && response.data.sound==1 && response.data.sound_file){
                                 if (self.$refs[response.data.sound_file])
                                     self.$refs[response.data.sound_file].play();
                                 else 
                                  console.warn(`Audio ref "${response.data.sound_file}" does not exist.`);
                            }
                            
                            
                            if(response.data.is==1){
                               self.gatepass= response.data.gatepass; 
                               self.showimgModal=false;
                               
                                 setTimeout(function () {
                                        window.location.replace(self.$cur_host + 'TabScan');
                                    }, 2000);
                            }
                                self.$swal(response.data.gatepassReq);
                        });
                    }
                });
            }else{
                  if(!passid){
                            self.$swal("Something Wrong");
                            return;
                        }
                
                        const formData = new FormData();
                        if(what==1){
                            const blob = self.dataURLtoBlob(self.selected_gatepass_captured_img);
                            formData.append('image', blob, 'captured_photo.png');
                        }
                        // formData.append('passid', passid);
                        formData.append('passid', passid);
                        formData.append('what', what);
                        
                        axios.post('qrcheckInUser', formData).then(function (response) {
                           if(response.data?.sound && response.data.sound==1 && response.data.sound_file){
                                 if (self.$refs[response.data.sound_file])
                                    self.$refs[response.data.sound_file].play();
                                 else 
                                  console.warn(`Audio ref "${response.data.sound_file}" does not exist.`);
                            }
                            
                            if(response.data.is==1){
                               self.gatepass= response.data.gatepass; 
                               self.showimgModal=false;
                               
                               
                                 setTimeout(function () {
                                        window.location.replace(self.$cur_host + 'TabScan');
                                    }, 2000);
                            }
                            
                            
                                self.$swal(response.data.gatepassReq);
                        });
            }

        },
        getBasics(token) {
            var self = this;
            axios.post('getVisitorpass',{token:token}).then(function (response) {
                   self.gatepass= response.data.gatepass; 
                   if(self.gatepass){
                        self.is_expired=false;
                       self.scan_user= response.data.scan_user; 
                       self.sd= response.data.sd; 
                       self.getQrCode(self.gatepass.token);
                       
                        if(response.data?.sound && response.data.sound==1 && response.data.sound_file){
                                 if (self.$refs[response.data.sound_file])
                                    self.$refs[response.data.sound_file].play();
                                 else 
                                  console.warn(`Audio ref "${response.data.sound_file}" does not exist.`);
                            }
                            
                            
                       if( self.scan_user.empdept == self.sd && self.gatepass.check_in !=null && self.gatepass.checkout_approval==1 && self.gatepass.check_out==null){
                           self.mark_checkin(self.gatepass.visitid,2);
                       }
                       
                   }else{
                       self.is_expired=true;
                        self.$swal("Sorry Page Expired");
                   }
                window.scrollTo(0, 0);
            });
        },
        async getQrCode(token) {
            try {
              if(token.length>0){
                  const canvas = this.$refs.qrcodeCanvas;
                  var url=this.$api_host+'vp?q='+token;
                  await QRCode.toCanvas(canvas,url , { width: 200 });
                  $("#qrcodeView").modal("toggle");
              }
              
            } catch (error) {
              console.error(error);
            }
          },
          show_img_modal(src,title){
              if(src=='QR'){
                    this.showingUserPic.src=this.$refs.qrcodeCanvas.toDataURL("image/png");;
                    this.showingUserPic.title=title;
                   $("#showingImg").modal("toggle");
              }else{
                  this.showingUserPic.src=src;
                  this.showingUserPic.title=title;
                  $("#showingImg").modal("toggle");
              }
               
          }

}
}
</script>
